import React from 'react';
import {Button} from "primereact/button";

interface AdminButtonProps {
  label: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: 'white' | 'grey' | 'black';
  className?: string;
  disabled?: boolean;
}

const AdminButton: React.FC<AdminButtonProps> = ({
  label,
  type = 'button',
  onClick,
  variant = 'white',
  className = '',
  disabled = false
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case 'white':
        return 'px-6 py-3 border border-gray-300 rounded-sm text-gray-700 hover:bg-gray-50 transition duration-200';
      case 'grey':
        return 'px-6 py-3 bg-gray-200 text-gray-700 rounded-sm hover:bg-gray-300 transition duration-200';
      case 'black':
        return 'px-6 py-3 bg-black text-white rounded-sm hover:bg-gray-800 transition duration-200';
      default:
        return 'px-6 py-3 border border-gray-300 rounded-sm text-gray-700 hover:bg-gray-50 transition duration-200';
    }
  };

  return (
    <Button
      type={type}
      label={label}
      onClick={onClick}
      disabled={disabled}
      className={`${getVariantClasses()} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    />
  );
};

export default AdminButton;
